import * as React from 'react';
export const calendarSvg = React.forwardRef(function calendarSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.34.75a.75.75 0 0 0-1.5 0v.75H3.5a3 3 0 0 0-3 3V13a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3V4.5a3 3 0 0 0-3-3h-1.35V.75a.75.75 0 0 0-1.5 0v.75H6.34V.75Zm3.31 3V3H6.34v.75a.75.75 0 0 1-1.5 0V3H3.5A1.5 1.5 0 0 0 2 4.5v1h12v-1A1.5 1.5 0 0 0 12.5 3h-1.35v.75a.75.75 0 0 1-1.5 0ZM14 7H2v6a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 14 13V7Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6 8H4v2h2V8Zm0 3H4v2h2v-2Zm3 0H7v2h2v-2Zm1 0h2v2h-2v-2ZM7 8h2v2H7V8Zm5 0h-2v2h2V8Z',
    }),
  );
});
calendarSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var calendar = {
  category: 'icon',
  colorable: true,
  name: 'calendar',
  svg: calendarSvg,
};
